import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-b border-black-200 pb-12 pt-16 text-black-900" }
const _hoisted_2 = { class: "text-14 font-medium" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "group flex cursor-pointer items-center justify-between",
      onClick: _cache[0] || (_cache[0] = $event => ($data.isOpen = !$data.isOpen))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.title), 1),
      _createVNode(_component_v_icon, {
        icon: "arrow-down",
        width: 14,
        height: 8,
        flipped: "",
        class: _normalizeClass(["transition-transform", $data.isOpen && '!rotate-[180deg]'])
      }, null, 8, ["class"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["grid text-12 transition-grid-template-rows duration-500", $data.isOpen ? 'grid-rows-1' : 'grid-rows-0'])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}